export function initBurger() {
    const buttonBurger = document.querySelectorAll('[data-hamburger]');
    const navContainer = document.querySelector('[data-header-nav]');

    buttonBurger.forEach((button) => {
        button.addEventListener('click', () => {
            navContainer.classList.toggle('--active');
        });
    });
}
